































































































import Vue, { PropType } from "vue";
import { ValidationProvider } from "vee-validate";
// types
import { Publisher, Client, Domain } from "@/features/coreWebVitals/types";
// utils
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  components: {
    "validation-provider": ValidationProvider,
  },
  props: {
    publisherInput: { type: Number, required: true },
    publishers: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    clientInput: { type: Number, required: true },
    clients: {
      type: Array as PropType<Client[]>,
      required: true,
    },
    domainInput: { type: Number },
    domains: {
      type: Array as PropType<Domain[]>,
      required: true,
    },
    fetchData: { type: Function as PropType<() => void> },
    clickCancel: { type: Function as PropType<() => void>, required: true },
    loading: { type: Boolean, required: true },
    isClientUser: { type: Boolean, required: true },
  },
  computed: {
    localPublisherInput: {
      get(): number {
        return (this as any).publisherInput;
      },
      set(val: number) {
        return this.$emit("update:publisherInput", val);
      },
    },
    localClientInput: {
      get(): number {
        return (this as any).clientInput;
      },
      set(val: number) {
        return this.$emit("update:clientInput", val);
      },
    },
    localDomainInput: {
      get(): number {
        return (this as any).domainInput;
      },
      set(val: number) {
        return this.$emit("update:domainInput", val);
      },
    },
  },
  methods: {
    handleFetchData() {
      if ((this as any).loading) {
        notifyUtil.notifyErrorMessage(this.$t("general.notify.error.loading"));
      } else {
        (this as any).fetchData();
      }
    },
  },
});

export type Labels = {
  publisher: string;
};
